import Vue from 'vue';
import { normalizeChartingPriceSeriesType } from '@/features/charting-next/models/chartingPriceSeriesTypes';
import {
  CHARTING_RESULT_SORT_ORIGINAL,
  normalizeChartingResultSortValue
} from '@/features/charting-next/models/chartingResultSorting';
import {
  DEFAULT_CHARTING_WORKSPACE_VIEW_MODE,
  normalizeChartingWorkspaceViewMode
} from '@/features/charting-next/models/chartingWorkspaceViewMode';

const context = Vue.observable({
  selectedTicker: '',
  selectedEntryVariantKeys: {},
  sourceSignature: '',
  resultSort: CHARTING_RESULT_SORT_ORIGINAL,
  workspaceViewMode: DEFAULT_CHARTING_WORKSPACE_VIEW_MODE,
  resolution: 'M',
  showVolume: false,
  priceSeriesType: 'bars',
  overlayVisibility: {
    support: true,
    stop: true,
    resistance: true,
    trendLine: true,
    trendPoint: true,
    riskRewardPoint: true
  },
  setSelectedTicker(ticker) {
    this.selectedTicker = ticker ? String(ticker).trim().toUpperCase() : '';
  },
  setSelectedEntryVariant(ticker, variantKey) {
    const normalizedTicker = ticker ? String(ticker).trim().toUpperCase() : '';
    if (!normalizedTicker) return;
    if (!variantKey) {
      Vue.delete(this.selectedEntryVariantKeys, normalizedTicker);
      return;
    }
    Vue.set(this.selectedEntryVariantKeys, normalizedTicker, String(variantKey).trim());
  },
  setResultSort(sortValue) {
    this.resultSort = normalizeChartingResultSortValue(sortValue);
  },
  setWorkspaceViewMode(viewMode) {
    this.workspaceViewMode = normalizeChartingWorkspaceViewMode(viewMode);
  },
  setResolution(resolution) {
    this.resolution = ['D', 'W', 'M'].includes(resolution) ? resolution : 'D';
  },
  setPriceSeriesType(priceSeriesType) {
    this.priceSeriesType = normalizeChartingPriceSeriesType(priceSeriesType);
  },
  setShowVolume(showVolume) {
    this.showVolume = Boolean(showVolume);
  },
  toggleShowVolume() {
    this.showVolume = !this.showVolume;
  },
  setOverlayVisibility(key, visible) {
    const normalizedKey = String(key || '').trim();
    if (normalizedKey && normalizedKey in this.overlayVisibility) {
      Vue.set(this.overlayVisibility, normalizedKey, Boolean(visible));
    }
  },
  toggleOverlayVisibility(key) {
    const normalizedKey = String(key || '').trim();
    if (normalizedKey && normalizedKey in this.overlayVisibility) {
      Vue.set(this.overlayVisibility, normalizedKey, !this.overlayVisibility[normalizedKey]);
    }
  },
  resetForSource(signature = '') {
    if (this.sourceSignature !== signature) {
      this.sourceSignature = signature;
      this.selectedTicker = '';
      this.selectedEntryVariantKeys = {};
    }
  }
});

export function useChartingContextStore() {
  return context;
}
